import React from 'react';
import useTheme from 'branding/theme';
import ModalWrapper from '../ModalWrapper';
import Section from '../../layout/Section';
import getBackgroundColor from './getBackgroundColor';
const Modal = ({ className, type = 'neutral', width = 'contained', noDefaultPadding, children, styles, xClassname, isDrawer = false, ...rest }) => {
    const { colors } = useTheme();
    const innerSectionStyles = {
        backgroundColor: getBackgroundColor(colors, type)
    };
    return (React.createElement(ModalWrapper, { className: className, type: "modal", hideLogo: true, noDefaultPadding: noDefaultPadding, innerSectionStyles: innerSectionStyles, xClassname: xClassname, isDrawer: isDrawer, ...rest }, () => (React.createElement(Section, { width: width, centered: true, noDefaultPadding: noDefaultPadding, styles: styles }, children))));
};
export default Modal;
//# sourceMappingURL=index.js.map